// extracted by mini-css-extract-plugin
export default {"overlay":"AlertComponent_overlay__JiJz3","loaderWrapper":"AlertComponent_loaderWrapper__36Bfm"};